import { useEffect } from "react";
import { useViewer } from "viewer/store/viewer";

export default function useScrollLock() {
  const selectedCamera = useViewer((state) => state.selectedCamera);

  useEffect(() => {
    if (selectedCamera.jid) window.document.body.style.overflow = "hidden";
    else window.document.body.style.overflow = "visible";
  }, [selectedCamera.jid]);
}
